import Reports from "../components/Reports/Reports";
import {PERM} from "../utilites/permissions";

const reports = [
  {
    path: '/reports',
    name: 'Reports',
    component: Reports,
    meta: {requiresAuth: true,
      permissions: [
        PERM.REPORT,
      ]
    },
    props: true,
  },
];

export default reports;



// WEBPACK FOOTER //
// ./src/router/reports.js